import { Component, computed, inject, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { noWhitespaceValidator } from "../../../../core/validators";
import { PageMode } from "../../../constants/enums";
import { IntpAchievementModel } from "../../../models";
import { FormInputComponent } from "../../form";

@Component({
  selector: "adaa-intp-visit-achievements-modal",
  imports: [TranslatePipe, ReactiveFormsModule, FormInputComponent],
  templateUrl: "./intp-visit-achievements-modal.html",
  styleUrl: "./intp-visit-achievements-modal.scss",
})
export class IntpVisitAchievementsModalComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _toastrService = inject(ToastrService);
  private readonly _translateService = inject(TranslateService);
  readonly modal = inject(NgbActiveModal);

  //Inputs
  pageMode = signal<PageMode>(PageMode.create);
  achievement = signal<IntpAchievementModel | undefined>(undefined);

  //Props
  model: FormGroup;
  submitted = false;

  isViewMode = computed(() => this.pageMode() === PageMode.view);

  public ngOnInit(): void {
    this.model = this._prepareForm();

    const achievement = this.achievement();
    if (achievement) this.model.patchValue(achievement);
  }

  public save() {
    this.submitted = true;

    if (!this.model.valid) {
      this._toastrService.warning(this._translateService.instant("notification.warning.missing_info"));
      return;
    }

    this.modal.close(this.model.getRawValue());
  }

  private _prepareForm() {
    return this._formBuilder.group({
      id: null,
      fakeId: null,
      textAE: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      textEN: [{ value: null, disabled: this.isViewMode() }, [Validators.required, noWhitespaceValidator()]],
      userNameAE: null,
      userNameEN: null,
      status: null,
    });
  }
}
